import "../../index41.css";
import { jsxs as N, jsx as V } from "react/jsx-runtime";
import { useLayoutEffect as D, useRef as x } from "react";
import { _ as h } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import O from "../../hooks/useSpacingToken.js";
import { getSpacingValue as j, fullSpacings as z, gapSpacings as E } from "../../utils/style.js";
const G = "_list-view_1g7g1_1", $ = "_grid-layout_1g7g1_5", T = "_grid-content_1g7g1_12", q = "_with-sidebar_1g7g1_15", A = "_sidebar-position-start_1g7g1_32", H = "_inline-layout_1g7g1_39", I = "_with-wrap_1g7g1_44", J = "_with-space-between-contents_1g7g1_49", K = "_with-centered-contents_1g7g1_53", M = "_block-layout_1g7g1_58", Q = "_with-full-width_1g7g1_67", U = "_with-background_1g7g1_71", X = "_with-dark-background_1g7g1_76", t = {
  listView: G,
  gridLayout: $,
  gridContent: T,
  withSidebar: q,
  sidebarPositionStart: A,
  inlineLayout: H,
  withWrap: I,
  withSpaceBetweenContents: J,
  withCenteredContents: K,
  blockLayout: M,
  withFullWidth: Q,
  withBackground: U,
  withDarkBackground: X
};
function Y(e) {
  const o = x(null);
  return e && typeof e != "function" ? e : o;
}
function st(e) {
  const {
    className: o,
    layout: i = "inline",
    withWrap: _,
    withSpaceBetweenContents: p,
    withCenteredContents: m,
    spacing: r,
    withPadding: s,
    withBackground: f,
    withDarkBackground: k,
    children: c,
    numPreferredGridColumns: a = 2,
    minGridColumnSize: g = "12rem",
    gridContentClassName: y,
    withSidebar: C,
    sidebarPosition: b = "end",
    spacingOffset: S,
    withFullWidth: P,
    elementRef: B,
    withSpacingOpticalCorrection: L = !1,
    ...W
  } = e, n = Y(B);
  D(() => {
    var l, u, w;
    if (i === "grid") {
      (l = n.current) == null || l.style.setProperty(
        "--num-preferred-grid-columns",
        String(a)
      ), (u = n.current) == null || u.style.setProperty(
        "--min-grid-column-size",
        String(g)
      );
      const v = s ? 2 : 0, F = a - 1, R = v + F;
      (w = n.current) == null || w.style.setProperty(
        "--reserved-space",
        `calc(${j(r)} * ${R})`
      );
    }
  }, [a, g, i, s, r, n]);
  const d = O({
    spacing: r,
    offset: S,
    modes: s ? z : E,
    withoutOpticalCorrection: !L
  });
  return /* @__PURE__ */ N(
    "div",
    {
      ...W,
      ref: n,
      className: h(
        t.listView,
        i === "inline" && t.inlineLayout,
        i === "block" && t.blockLayout,
        i === "grid" && t.gridLayout,
        i !== "grid" && d,
        _ && t.withWrap,
        p && t.withSpaceBetweenContents,
        m && t.withCenteredContents,
        P && t.withFullWidth,
        f && t.withBackground,
        k && t.withDarkBackground,
        o
      ),
      role: i !== "grid" ? "list" : void 0,
      children: [
        i === "grid" && /* @__PURE__ */ V(
          "div",
          {
            className: h(
              t.gridContent,
              d,
              y,
              C && t.withSidebar,
              b === "start" && t.sidebarPositionStart
            ),
            role: "grid",
            children: c
          }
        ),
        i !== "grid" && c
      ]
    }
  );
}
export {
  st as default
};
